import styles from "./textCard.module.scss"
export function TextCard({sourceText}) {
    return <p className={styles.card__text}>{sourceText}</p>
}